// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"228":"404notfound","309":"termsandconditions","609":"faq","987":"privacypolicy"}[chunkId] + "." + {"228":"8e2cd79b","309":"83708c90","609":"aa37a09d","987":"3b6bfd34"}[chunkId] + ".js";
};